import { useContext } from 'react';
import HeaderContext from '../../contexts/HeaderContext';

const useHeaderContext = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeaderContext must be used within HeaderContextProvider!');
  }
  return context;
};

export default useHeaderContext;
